import { atom } from "recoil";
import { APP_STATE_KEYS } from "@/constants/app-state.constants";
import { UISettingModel } from "@/models/system-config";
import LocalUtils from "@/utils/local.utils";
import { LOCAL_STORAGE_KEY, LOCAL_UI_STORAGE_VALUE, SESSION_TIMEOUT_CONFIG } from "@/constants/app-constants";

const configString = LocalUtils.get(LOCAL_STORAGE_KEY.SYSTEM_CONFIG_DATA)
const configObj: UISettingModel = configString ? JSON.parse(configString) : {
  uiBrowserTitle: LOCAL_UI_STORAGE_VALUE.BROSWE_TITLE,
  uiLogoImage: LOCAL_UI_STORAGE_VALUE.LOGO_CloudPOS_PATH,
  uiWelcomeImage: LOCAL_UI_STORAGE_VALUE.WELCOME_IMAGE_PATH,
  inactivityLogout: SESSION_TIMEOUT_CONFIG.sessionWarningTime
};

const uiSettingState = atom<UISettingModel>({
  key: APP_STATE_KEYS.UI_SETTTING_STATE,
  default: {
    uiBrowserTitle: configObj.uiBrowserTitle ? configObj.uiBrowserTitle : LOCAL_UI_STORAGE_VALUE.BROSWE_TITLE,
    uiLogoImage: configObj.uiLogoImage ? configObj.uiLogoImage : LOCAL_UI_STORAGE_VALUE.LOGO_CloudPOS_PATH,
    uiWelcomeImage: configObj.uiWelcomeImage ? configObj.uiWelcomeImage : LOCAL_UI_STORAGE_VALUE.WELCOME_IMAGE_PATH,
    inactivityLogout: configObj.inactivityLogout ? configObj.inactivityLogout : SESSION_TIMEOUT_CONFIG.sessionWarningTime,
    isAllowAddDevice: configObj.isAllowAddDevice ? configObj.isAllowAddDevice : false,
  }
});

export { uiSettingState };
